import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as D3 from 'd3';
import { fromEvent, Subscription } from 'rxjs';
import {filter, take} from'rxjs/operators'
import { BASE_STROKE_WIDTH } from '../core/const';
@Component({
  selector: 'k-renderer',
  templateUrl: './renderer.component.html',
  styleUrls: ['./renderer.component.less']
})
export class RendererComponent implements OnInit,OnChanges {

  @ViewChild('wrapper',{static:true}) wrapper:ElementRef
  @ViewChild('canvas',{static:true}) canvas:ElementRef

  // @Input() color:string

  @Input() showAnimation:boolean 
  @Input() url
  @Input() annotationData
  @Input() index
  @Input() 
  set currentActiveIndex(value){
    this._currentActiveIndex = value;
    this.makeTranslateX();
    
  }
  get currentActiveIndex(){
    return this._currentActiveIndex
  }
  private _currentActiveIndex:number = 0;

  translateX:number = 0;


  data = {
    scale:0,
    canvasSize:{
      width:0,
      height:0
    },
    imageSize:{
      width:0,
      height:0
    },
    top:0,
    left:0,
    offset:0
  };
  
  content:SVGSVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg')  ;
  text:SVGSVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  testText = document.createElement('div')

  wheelHandler$:Subscription|null = null;
  dragTrigger$:Subscription|null = null;
  dragCancel$:Subscription|null = null;
  drawHandler$:Subscription|null = null;

  lastDragPosition={
    x:0,
    y:0
  };

  svgShapes:any=[];
  svgTexts:any[] = [];

  rendered:boolean = false;

  canvasRender

  isMouseDown:boolean = false;


  
 

  constructor() { }

  ngOnChanges(change:SimpleChanges){
    if(change.currentActiveIndex){
      this.checkShouldRender()
    }
    
    // if(change.url){
    //   this.makeImage()
    // }
  }
  ngOnInit(): void {
     
    this.content.setAttribute('id', 'cvat_canvas_content');
    this.text.setAttribute('id', 'cvat_text_content');
    this.testText.setAttribute('id','testDiv')
     
    this.wrapper.nativeElement.appendChild(this.content)
    this.wrapper.nativeElement.appendChild(this.text)
  
    this.wrapper.nativeElement.appendChild(this.testText)
  }
  checkShouldRender(){
    if(this.currentActiveIndex==this.index && this.url){
  
      this.makeImage()
      this.setupEventsHandlers()
    }else if(this.currentActiveIndex!==this.index ){
      this.removeEventsHandlers();
      this.reset();
 
    }
  }
  setupEventsHandlers(){
 
    this.wheelHandler$= fromEvent<WheelEvent>(this.content,'wheel')
    .subscribe(
      res=>{
        this.data.offset
        const point = translateToSVG(this.content,[res.clientX,res.clientY])

        this.zoom(point[0]-this.data.offset,point[1]-this.data.offset,res.deltaY>0?-1:1 )

      }
    )
     
    this.dragTrigger$ = fromEvent<MouseEvent>(this.content,'mousedown')
    .subscribe(
      res=>{
        res.preventDefault();
        if(res.button!==0) return
        this.lastDragPosition.x = res.clientX;
        this.lastDragPosition.y = res.clientY;
        this.isMouseDown = true;

        

      }
    )

    this.drawHandler$ = fromEvent<MouseEvent>(this.content,'mousemove')
    .pipe(
      filter(()=>{
        return this.isMouseDown
      })
    )
    .subscribe(
      res=>{
        const topOffset = res.clientY - this.lastDragPosition.y;
        const leftOffset =  res.clientX - this.lastDragPosition.x;

        this.lastDragPosition.x = res.clientX;
        this.lastDragPosition.y = res.clientY;

        this.move(topOffset,leftOffset);
        console.log(this.isMouseDown)
      }
    );

      this.dragCancel$ = fromEvent(document,'mouseup')
        .subscribe(
          res=>{
            this.isMouseDown = false
              
            // if(this.drawHandler$){
            //   this.drawHandler$.unsubscribe();
            //   this.drawHandler$ = null;
            // };
            
          }
        )
  }
  removeEventsHandlers(){
    if(this.wheelHandler$){
       
      this.wheelHandler$.unsubscribe();
      this.wheelHandler$ = null;
    }

    if(this.dragCancel$){
      this.dragCancel$.unsubscribe();
      this.dragCancel$ = null;
    }

    if(this.drawHandler$){
      this.drawHandler$.unsubscribe();
      this.drawHandler$ = null;
    }
  
  }


  makeImage(){
 
    let _this = this;

    let image = new Image();
    image.src = this.url;
    let canvas:HTMLCanvasElement = this.canvas.nativeElement

    this.canvasRender = canvas;

    let ctx = canvas.getContext('2d');
    image.onload = function(res){
      canvas.height = image.height;
      canvas.width = image.width;
 
      _this.data.imageSize.width = image.width;
      _this.data.imageSize.height = image.height;

      
      _this.notify(updateReasons.IMAGE_CHANGED)

       
      ctx.drawImage(image,0,0);

      // _this.moveCanvas()
      _this.fitCanvas();
 
      // _this.transformCanvas();
      // _this.fitCanvas();
      
      _this.setupObjects(_this.annotationData);

      _this.rendered = true;
    };


  }
  moveCanvas(){
    this.canvas.nativeElement.style.top = this.data.top+'px';
    this.canvas.nativeElement.style.left = this.data.left+'px';

    this.content.style.top = `${this.data.top - this.data.offset}px`;
    this.content.style.left = `${this.data.left - this.data.offset}px`;

    this.text.style.top = `${this.data.top - this.data.offset}px`;
    this.text.style.left = `${this.data.left - this.data.offset}px`;

    //////////////////////////////////////////////////
    this.testText.style.top = `${this.data.top - this.data.offset}px`;
    this.testText.style.left = `${this.data.left - this.data.offset}px`;
    
  }
  fitCanvas(){
    let height = this.wrapper.nativeElement.clientHeight;
    let width = this.wrapper.nativeElement.clientWidth;

    this.data.offset = Math.floor(
      Math.max(
        height/FrameZoom.MIN,
        width/FrameZoom.MIN
      )
    );

    this.data.canvasSize.height = height;
    this.data.canvasSize.width = width;


      
    this.notify(updateReasons.IMAGE_FITTED)
    this.notify(updateReasons.FITTED_CANVAS)
  }
  resizeCanvas(){
    this.canvas.nativeElement.style.width = this.data.imageSize.width+'px';
    this.canvas.nativeElement.style.height = this.data.imageSize.height+'px';
     
    this.content.style.width = `${this.data.imageSize.width + this.data.offset*2}px`;
    this.content.style.height = `${this.data.imageSize.height + this.data.offset*2}px`
     
    this.text.style.width = `${this.data.imageSize.width + this.data.offset*2}px`;
    this.text.style.height = `${this.data.imageSize.height + this.data.offset*2}px`
    ////////////////////////////////

    this.testText.style.width = `${this.data.imageSize.width + this.data.offset*2}px`;
    this.testText.style.height = `${this.data.imageSize.height + this.data.offset*2}px`
  }
  transformCanvas(){
    this.canvas.nativeElement.style.transform = `scale(${this.data.scale})`;
    this.content.style.transform = `scale(${this.data.scale})`;
    this.text.style.transform = `scale(${this.data.scale})`;
    //////////////////////////////////////
    this.testText.style.transform = `scale(${this.data.scale})`;

    for(let item of this.svgTexts){
      item.style.fontSize = `${14/this.data.scale *10}%`;
    }
 
    this.svgShapes.forEach(element => {
      element.attr('stroke-width',BASE_STROKE_WIDTH / this.data.scale);
    });
  }

  fit(){
    let scale  = Math.min(
      this.data.canvasSize.width / this.data.imageSize.width,
      this.data.canvasSize.height / this.data.imageSize.height,
    );
    
    this.data.scale = Math.min(
      Math.max(scale, FrameZoom.MIN),
      FrameZoom.MAX,
    );
    
    this.data.top = (this.data.canvasSize.height / 2 - this.data.imageSize.height / 2);
    this.data.left = (this.data.canvasSize.width / 2 - this.data.imageSize.width / 2);
    
    this.notify(updateReasons.IMAGE_FITTED)
  }
  ////////////////////////////

  setupObjects(states){
    let offset = this.data.offset;
    const translate = (points: number[]): number[] => points.map((coord: number): number => coord + offset);

 

    for(let state of states){
      const translatedPoints = translate(state.points)
        
       if(state.type=="rectangle"){
          this.addRect(translatedPoints,state);
       }else if (state.type=="polygon"){
         const stringified = translatedPoints.reduce(
          (acc: string, val: number, idx: number): string => {
            if (idx % 2) {
              return `${acc}${val} `;
            }

            return `${acc}${val},`;
          }, '',
         );
          
         this.addPolygon(stringified,state)
       }
     

      this.addText(translatedPoints,state)
    }

    // let points =  this.annotationData.points.map(res=>res+offset)
    // const [xtl, ytl, xbr, ybr] = points;


  }
  addText(points,state){
     
  //   let text = D3.select(this.text)
  //   .append('text')
  //   .attr('x',points[0])
  //   .attr('y',points[1])
  //   .classed('cvat_canvas_text',true)

  //   let sourcetext =  ' 手动标注' 

  //   text
  //  .selectAll('tspan.title_span')
  //  .data([1])
  //  .enter()
  //  .append('tspan')
  //  .classed('title_span',true)
  //  .text(function(d){
  //    return `  (${sourcetext} )`
  //  })

 
   let testdom:HTMLDivElement = document.createElement('div')
   testdom. innerHTML=state.label?state.label:'';
   testdom.style.position='absolute';
   testdom.style.left = points[0]+'px';
   testdom.style.top = points[1]+'px';

    
  testdom.style.fontSize = `${14/this.data.scale*10 }%`;

   this.testText.appendChild(testdom);

   this.svgTexts.push(testdom);
  //  text
  //  .append('foreignobject')
  // //  .attr('x',points[0]).attr('y',points[1]).attr('width','180').attr('height','50')
  //  .attr('x',0).attr('y',85).attr('width','180').attr('height','50')
  //  .append('div')
  //  .attr('xmlns', 'http://www.w3.org/1999/xhtml')
  //  .text('123')

  }

  addRect(points,state){
 
    const [xtl, ytl, xbr, ybr] = points;

    let rect = D3.select(this.content)
    .append('rect')
    // .attr('clientid',state.clientID)
    //  .attr('id',`kvat_canvas_shape_${state.clientID}`)
    //  .attr('fill',state.color)
     .attr('fill-opacity',0.03)
     .attr('stroke',state.color)
     .attr('stroke-width',BASE_STROKE_WIDTH / this.data.scale)
     .attr('color-rendering','optimizeQuality')
     .attr('shape-rendering','geometricprecision')
    //  .attr('data-z-order',state.zOrder)
     .attr('width',xbr-xtl)
     .attr('height',ybr-ytl)
     .attr('x',xtl)
     .attr('y',ytl)
     .classed('kvat_canvas_shape',true)

     this.svgShapes.push(rect)
  }

  addPolygon(points: string, state: any){
    let polygon = D3.select(this.content)
    .append('polygon')
    // .attr('id',`kvat_canvas_shape_${state.clientID}`)
    // .attr('fill',state.color)
    .attr('fill-opacity',0.03)
    .attr('stroke',state.color)
    .attr('stroke-width',BASE_STROKE_WIDTH / this.data.scale)
    .attr('color-rendering','optimizeQuality')
    .attr('shape-rendering','geometricprecision')
    // .attr('data-z-order',state.zOrder)
    .attr('points',points)
    .classed('kvat_canvas_shape',true);

    this.svgShapes.push(polygon);
  }

  makeTranslateX(){
    let t = this.wrapper.nativeElement.clientWidth;
    this.translateX = (this.index - this._currentActiveIndex)*t;
   
    this.wrapper.nativeElement.style.transform = `translateX(${this.translateX}px)`
     
  }

  zoom(x: number, y: number, direction: number){
    const oldScale: number = this.data.scale;
    const newScale: number = direction > 0 ? oldScale * 6 / 5 : oldScale * 5 / 6;
    this.data.scale = Math.min(Math.max(newScale, FrameZoom.MIN), FrameZoom.MAX);
    // const mutiplier = Math.sin(0 * Math.PI / 180) + Math.cos(0 * Math.PI / 180);
    // debugger
    this.data.left +=   ((x - this.data.imageSize.width / 2)* (oldScale / this.data.scale - 1)) * this.data.scale;
    this.data.top +=   ((y - this.data.imageSize.height / 2)* (oldScale / this.data.scale - 1)) * this.data.scale;

    this.notify(updateReasons.IMAGE_ZOOMED);
  }

  move(topOffset:number,leftOffset:number){
    this.data.top+=topOffset;
    this.data.left +=leftOffset;
    this.notify(updateReasons.IMAGE_MOVED)
  }

  reset(){
    while(this.svgTexts.length){
      let t = this.svgTexts.pop();
      t.remove();
    }

    while(this.svgShapes.length){
      let t = this.svgShapes.pop();
      t.remove();
    }
  }
  rerender(){
    if(this.rendered){
      this.fitCanvas();
      this.reset();
      this.setupObjects(this.annotationData);
    }

    this.makeTranslateX()
  }

  notify(reason:updateReasons){
    if(reason==updateReasons.IMAGE_CHANGED){
      this.fit()
      this.moveCanvas();
      this.resizeCanvas();

      this.transformCanvas();
    }else if (reason == updateReasons.FITTED_CANVAS){
      this.fit()
      this.moveCanvas();
      this.resizeCanvas();
    }else if ([updateReasons.IMAGE_ZOOMED,updateReasons.IMAGE_FITTED].includes(reason)){
      this.moveCanvas();
      this.transformCanvas();
    }else if( reason == updateReasons.IMAGE_MOVED){
      this.moveCanvas()
    }
  }

 

}



export enum updateReasons {
  IMAGE_CHANGED = "image_changed",
  IMAGE_ZOOMED = 'image_zoomed',
  IMAGE_FITTED = 'image_fitted',
  IMAGE_MOVED = 'image_moved',
  FITTED_CANVAS = 'fitted_canvas',
  // OBJECTS_UPDATED = 'objects_updated',

}

enum FrameZoom{
  MIN=0.1,
  MAX=10
}


 function translateToSVG (svg:SVGSVGElement,points:number[]):number[]{
     
  const output = [];
  const transformationMatrix = (svg.getScreenCTM() as DOMMatrix ).inverse();
  let pt = svg.createSVGPoint();

  for(let i =0;i<points.length;i+=2){
      pt.x = points[i];
      pt.y = points[i+1];
      pt = pt.matrixTransform(transformationMatrix);
      output.push(pt.x,pt.y)
  }
  return output;
}